// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

// Util
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Third Party libraries
import * as $ from 'jquery';

// Services
import OrdersService from '@/app/services/main/orders/orders-service';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

export default {
	name: 'ModalDisapproveCancellationRequest',
	mixins: [toastMessageMixins],
	data() {
		return {
			disapproveText: '',
			isAPILoading: false,
			orderDetails: null
		}
	},
	computed: {
		validationRules() {
			let field = {
				disapproveText: {}
			};

			field = vuelidateUtil.setRequiredValidation(field, 'disapproveText');

			return field;
		}
	},
	mounted() {
		$(this.$refs.modalDisapproveRequest).on('hide.bs.modal', this.handleHideEvent);
	},
	beforeDestroy() {
		this.closeModal();
		$(this.$refs.modalDisapproveRequest).off('hide.bs.modal', this.handleHideEvent);
	},
	methods: {
		openModal(orderDetails) {
			this.resetFields();
			this.orderDetails = orderDetails;
			$(this.$refs.modalDisapproveRequest).modal('show');
		},
		closeModal() {
			$(this.$refs.modalDisapproveRequest).modal('hide');
		},
		resetFields() {
			this.disapproveText = '';
			this.orderDetails = null;
			this.$v.$reset();
		},
		handleHideEvent() {
			this.$emit('returnToOrderDetails', this.orderDetails.id);
		},
		submitDisapprove() {
			if (this.$v.$invalid) {
				return;
			}

			const response = { reason: this.disapproveText };
			this.isAPILoading = true;
			
			OrdersService.putDisapproveCancelOrder(this.orderDetails.id, response)
				.then(res => {
					const { SUCCESS_DISAPPROVE_CANCELLATION, ERROR_DISAPPROVE_CANCELLATION } = this.toastMessages.order();

					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.showCustomSuccessToast(SUCCESS_DISAPPROVE_CANCELLATION, '');
						this.closeModal();
						this.orderActioned();
					} else {
						this.showAPIErrorToast(ERROR_DISAPPROVE_CANCELLATION, res);
					}

					this.isAPILoading = false;
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isAPILoading = false;
				});
		},
		orderActioned() {
			this.$emit('refreshTableContent');
		}
	},
	validations() {
		return this.validationRules;
	}
}